"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isArrayBuffer = undefined;

var _isArrayBuffer = require("lodash/isArrayBuffer");

Object.defineProperty(exports, "isArrayBuffer", {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_isArrayBuffer).default;
    }
});
exports.isDataView = isDataView;
exports.isStringNumberKey = isStringNumberKey;

var _spec = require("./spec");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isDataView(view) {
    return view instanceof DataView;
}

function isStringNumberKey(key) {
    return typeof key === "string" && key === (0, _spec.ToInteger)(key) + "";
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@petamoriken/float16/lib/is.js
// module id = 58
// module chunks = 0